<script setup>
  useTheme().setTheme('dark');

  useBackToTop().backToTopActive.value = true;
</script>

<!----------------------------------------------------------------------------->

<template>
  <SearchResults>Search Results</SearchResults>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped></style>
